module.exports = __webpack_public_path__ + "img/home_new-active.698ce9f4.svg";